import { NgModule } from "@angular/core";
import { CguInput, CguPopupComponent, CguResult } from "./cgu-popup.component";
import { ModalDialogService } from "../../modal-dialog/modal-dialog.service";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    declarations: [CguPopupComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatIconModule,
        TranslateModule
    ],
    exports: [CguPopupComponent],
    providers: [ModalDialogService<CguResult, CguInput>]
})
export class CguPopupModule { }
